'use client';

import React from 'react';

export const useLogic = ({}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleOpenFilter = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.target as HTMLButtonElement);
  };

  const handleCloseFilter = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    handleOpenFilter,
    handleCloseFilter,
  };
};
